import { componentQrl, inlinedQrl, useStylesQrl, useContext, useSignal, useTaskQrl, useLexicalScope, _qrlSync, _jsxS, _jsxC, Slot, _fnSignal } from "@builder.io/qwik";
import { modalContextId } from "./modal-context.qwik.mjs";
import styles from "./modal.css.qwik.mjs";
import { useModal } from "./use-modal.qwik.mjs";
const HModalPanel = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  useStylesQrl(/* @__PURE__ */ inlinedQrl(styles, "HModalPanel_component_useStyles_Fb1QyyvmFFg"));
  const modal = useModal();
  const context = useContext(modalContextId);
  const panelRef = useSignal();
  useTaskQrl(/* @__PURE__ */ inlinedQrl(async function toggleModal({ track, cleanup }) {
    const [context2, modal2, panelRef2] = useLexicalScope();
    const isOpen = track(() => context2.showSig.value);
    if (!panelRef2.value)
      return;
    const focusTrap = await modal2.trapFocus(panelRef2.value);
    if (isOpen) {
      const storedRequestAnimationFrame = window.requestAnimationFrame;
      window.requestAnimationFrame = () => 42;
      await modal2.showModal(panelRef2.value);
      window.requestAnimationFrame = storedRequestAnimationFrame;
      await context2.onShow$?.();
      modal2.activateFocusTrap(focusTrap);
    } else {
      await modal2.closeModal(panelRef2.value);
      await context2.onClose$?.();
    }
    cleanup(async () => {
      await modal2.deactivateFocusTrap(focusTrap);
    });
  }, "HModalPanel_component_useTask_lr6cNK1Egkg", [
    context,
    modal,
    panelRef
  ]));
  const closeOnBackdropClick$ = /* @__PURE__ */ inlinedQrl(async (e) => {
    const [context2, modal2, panelRef2] = useLexicalScope();
    if (context2.alert === true || context2.closeOnBackdropClick === false)
      return;
    if (!(e.target instanceof HTMLDialogElement))
      return;
    if (await modal2.wasModalBackdropClicked(panelRef2.value, e))
      context2.showSig.value = false;
  }, "HModalPanel_component_closeOnBackdropClick_0BUFMph3sB0", [
    context,
    modal,
    panelRef
  ]);
  const handleKeyDownSync$ = _qrlSync((e) => {
    const keys = [
      " ",
      "Enter"
    ];
    if (e.target instanceof HTMLDialogElement && keys.includes(e.key))
      e.preventDefault();
    if (e.key === "Escape")
      e.preventDefault();
  }, 'e=>{const keys=[" ","Enter"];if(e.target instanceof HTMLDialogElement&&keys.includes(e.key)){e.preventDefault();}if(e.key==="Escape"){e.preventDefault();}}');
  const handleKeyDown$ = /* @__PURE__ */ inlinedQrl((e) => {
    const [context2] = useLexicalScope();
    if (e.key === "Escape") {
      context2.showSig.value = false;
      e.stopPropagation();
    }
  }, "HModalPanel_component_handleKeyDown_mSW13XGQEa0", [
    context
  ]);
  return /* @__PURE__ */ _jsxS("dialog", {
    ...props,
    get id() {
      return `${context.localId}-root`;
    },
    get "aria-labelledby"() {
      return `${context.localId}-title`;
    },
    get "aria-describedby"() {
      return `${context.localId}-description`;
    },
    get "data-state"() {
      return context.showSig.value ? "open" : "closed";
    },
    get "data-open"() {
      return context.showSig.value && "";
    },
    get "data-closed"() {
      return !context.showSig.value && "";
    },
    get role() {
      return context.alert === true ? "alertdialog" : "dialog";
    },
    ref: panelRef,
    children: /* @__PURE__ */ _jsxC(Slot, null, 3, "v3_0"),
    onKeyDown$: [
      handleKeyDownSync$,
      handleKeyDown$,
      props.onKeyDown$
    ],
    onClick$: /* @__PURE__ */ inlinedQrl(async (e) => {
      const [closeOnBackdropClick$2] = useLexicalScope();
      e.stopPropagation();
      await closeOnBackdropClick$2(e);
    }, "HModalPanel_component_dialog_onClick_0h2jSAzVAWU", [
      closeOnBackdropClick$
    ])
  }, {
    id: _fnSignal((p0) => `${p0.localId}-root`, [
      context
    ], "`${p0.localId}-root`"),
    "aria-labelledby": _fnSignal((p0) => `${p0.localId}-title`, [
      context
    ], "`${p0.localId}-title`"),
    "aria-describedby": _fnSignal((p0) => `${p0.localId}-description`, [
      context
    ], "`${p0.localId}-description`"),
    "data-state": _fnSignal((p0) => p0.showSig.value ? "open" : "closed", [
      context
    ], 'p0.showSig.value?"open":"closed"'),
    "data-open": _fnSignal((p0) => p0.showSig.value && "", [
      context
    ], 'p0.showSig.value&&""'),
    "data-closed": _fnSignal((p0) => !p0.showSig.value && "", [
      context
    ], '!p0.showSig.value&&""'),
    role: _fnSignal((p0) => p0.alert === true ? "alertdialog" : "dialog", [
      context
    ], 'p0.alert===true?"alertdialog":"dialog"')
  }, 0, "v3_1");
}, "HModalPanel_component_qYXi7QS59Gc"));
export {
  HModalPanel
};
